import { fetchIncidentCapabilitiesProvisionState } from './fetch-incident-capabilities-provision-state';
import { provisionIncidentCapabalities } from './provision-incident-capabilities';

export const actions = {
	fetchIncidentCapabilitiesProvisionState,
	provisionIncidentCapabalities,
};

export type Actions = typeof actions;
